import { PlaceholderPage } from './PlaceholderPage';

export const ReportingPage = () => <PlaceholderPage title="Reporting" />;
